import { API } from "API/API";
import { Constants } from "../../constants/constants";

const page_by_slug = async (slug, cpt = false) => {
  const query = cpt ? "?cpt=" + cpt : "";

  const result = await API.get.wp("pages/by_slug/" + slug + query, null, {
    next: {
      tags: ["everything", "pages", "page_slug_" + slug],
    },
  });

  if (result?.error) {
    console.error(result);
  }
  return result?.data;
};

const page_by_id = async (id, cpt = false) => {
  const query = cpt ? "?cpt=" + cpt : "";

  const result = await API.get.wp("pages/by_id/" + id + query, null, {
    next: {
      tags: ["everything", "pages", "page_id_" + id],
    },
  });

  if (result?.error) {
    console.error(result);
  }
  return result?.data;
};

const page_by_slug_yoast = async (slug, cpt = "pages") => {
  const result = await API.get.basic(
    Constants.api_url + "wp-json/wp/v2/" + cpt + "?slug=" + slug,
    null,
    {
      next: {
        tags: ["everything", "pages", "page_slug_" + slug],
      },
    }
  );

  return result[0];
};

const allPages = async (cpt = false) => {
  const query = cpt ? "?cpt=" + cpt : "";

  const result = await API.get.wp("pages/all" + query, null, {
    next: {
      tags: ["everything", "pages", "all_pages"],
    },
  });

  if (result?.error) {
    console.error(result);
  }
  return result?.data;
};

export const pages = {
  get: {
    all: allPages,
    bySlug: page_by_slug,
    byId: page_by_id,
    bySlugYoast: page_by_slug_yoast,
  },
};
